var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"base-duration c1",class:{ __transparent: _vm.transparent },style:(("background-color: " + _vm.backgroundColor + ";"))},[_vm._v(_vm._s(_vm.duration))])}
var staticRenderFns = []

export { render, staticRenderFns }